import { useNavigate } from "react-router-dom";
import BackButton from "../../common/components/BackButton";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import { useApp } from "../../common/contexts/AppContext";

function getFormInputs(component = {}) {
  const { name, description, startDate } = component;

  const formInputs = [
    {
      type: "text",
      name: "name",
      label: "Component name",
      placeholder: "Component name",
      validation: {
        required: "Component name is required",
      },
      defaultValue: name,
    },
    {
      type: "textarea",
      name: "description",
      label: "Description",
      placeholder: "Description",
      defaultValue: description,
    },
    {
      type: "date",
      name: "startDate",
      label: "Start Date",
      validation: {
        required: "Start Date is required",
      },
      max: new Date().toISOString().split("T")[0],
      defaultValue: startDate
        ? new Date(startDate).toISOString().split("T")[0]
        : null,
    },
  ];

  return formInputs;
}

function ComponentForm({
  onSubmit,
  onDeleteComponent,
  isSubmitting,
  component,
  id,
}) {
  const navigate = useNavigate();
  const { isOwner } = useApp();

  const deleteComponentHandler = () => {
    onDeleteComponent(id);
  };

  return (
    <div>
      <div className="flex justify-between items-center pb-8 border-b">
        <div className="text-2xl font-bold">Add Component</div>
        <BackButton onClick={() => navigate("/components")}>
          Back to components
        </BackButton>
      </div>

      <FormBuilder
        formInputs={getFormInputs(component)}
        submitButtonLabel={`${id ? "Save" : "Create"} Component`}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        submitBtnContainerCls="!w-fit"
      />

      {isOwner && id ? (
        <div className="flex justify-between items-center pb-8 border-b">
          <div className="text-2xl font-bold"></div>
          <button
            type="button"
            style={{ backgroundColor: "red" }}
            onClick={deleteComponentHandler}
            className={`rounded-md common_bg text-white w-half px-4 py-2 nav_link-500 transition ease-in-out duration-300`}
          >
            Delete Component
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default ComponentForm;
